import * as React from 'react';
import { Link } from 'gatsby';
import {
  NODE_BR, NODE_PARAGRAPH, render,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import { getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

export default function MeetTeammember({ blok }) {
  const {
    title,
    text,
    listItems,
    listpoints,
    image,
    button,
    buttonText,
  } = blok;
  const imageFilename = image?.[0]?.filename;
  const { width: imageWidth, height: imageHeight } = getStoryblokDimensions(imageFilename);

  return (
    <div className="bg-black px-8 lg:px-20 green-background-double py-[70px] text-white flex justify-between flex-col lg:flex-row">
      <div className="w-full flex justify-left xl:justify-center lg:w-7/12 flex flex-col">
        <FancyTitle
          text={title}
          tag="h2"
          className="mb-8"
        />
        {image && (
          <img
            src={image[0].filename}
            alt={getStoryblokAlt(image[0], '')}
            width={imageWidth}
            height={imageHeight}
            className="w-full rounded-full aspect-square block lg:hidden max-w-[400px] m-auto mb-8"
            loading="lazy"
            decoding="async"
          />
        )}
        <p dangerouslySetInnerHTML={{ __html: text }} />

        {listItems && (
          <p className="mt-8 leading-[3] pl-[16px]" dangerouslySetInnerHTML={{ __html: listItems }} />
        )}
        {listpoints && (
        <ul className="list-disc pl-4 pt-2">
          {listpoints?.content[0].content?.map((listItem) => (
            <li className="py-[8px]">{listItem.content[0].content[0].text}</li>
          ))}
        </ul>
        )}
        <Link to={button.url ? button.url : button.cached_url} title={button?.link_title || undefined} className="button-general mt-8 w-max">
          {render(buttonText, {
            nodeResolvers: {
              [NODE_PARAGRAPH]: (children) => <p>{children}</p>,
              [NODE_BR]: () => <br />,
            },
          })}

        </Link>
      </div>
      {image && (
        <div className="w-full lg:w-4/12">
          <img
            src={image[0].filename}
            alt={getStoryblokAlt(image[0], '')}
            width={imageWidth}
            height={imageHeight}
            className="w-full rounded-full aspect-square hidden lg:block"
            loading="lazy"
            decoding="async"
          />
        </div>
      )}
    </div>
  );
}
